'use strict';

const ContactUIStore = require('../stores/ContactUIStore');
const ContactMessageStore = require('../stores/ContactMessageStore');
const ContactTransactionStore = require('../stores/ContactTransactionStore');
const gaActions = require('./gaActions');
const Transaction = require('bunsen/models/ecomm/Transaction');
const Transactions = require('bunsen/collections/ecomm/Transactions');
const TransactionValidator = require('bunsen/validation/deprecated/validators/ecom/4.3/TransactionValidator');
const { Deferred } = require('simply-deferred');
const checkoutRedirects = require('../../../checkout/helpers/checkout-redirects.es');
const contains = require('lodash.contains');

const actions = (module.exports = {
    editOfferField(actionContext, payload) {
        if (payload.calculateAmountOff) {
            actionContext.dispatch('contact:form:lowball:options:offer', payload);
        }
        actionContext.dispatch('contact:offer:fieldEdited', payload);
    },

    /**
     *  Validates the transaction in the ContactTransactionStore.
     *
     *  @param payload.bypassLowball {bool}
     *  @param payload.showLowballOptions {bool}
     *  @param payload.source {string}
     *  @returns {array}
     */
    validateOffer(actionContext, payload) {
        const { copyText, user } = actionContext.getStore(ContactUIStore).state;
        const { transaction, offer } = actionContext.getStore(ContactTransactionStore);
        const item = transaction.get('item');
        const validator = new TransactionValidator({ copyText: copyText || payload.copyText });
        const errors = validator.validate(transaction).errors;
        const isTrade = user && user.isVerifiedTradeBuyer() && item && item.isFurniture();
        if (!errors.length && !payload.bypassLowball) {
            if (validator.validateLowball(transaction, { isTrade })) {
                if (payload.showLowballOptions) {
                    actionContext.dispatch('contact:form:lowball:options:init', {
                        offerAmount: offer.get('amountPerItem.amount'),
                    });
                }
                actionContext.dispatch('contact:form:lowBall:show');
                errors.push({
                    field: 'lowball',
                    message: copyText.get('offerLowballLabel'),
                });
            }
        }
        if (errors.length) {
            gaActions.eventOfferError(actionContext, {
                source: payload.source,
                errorMessage: errors[0].message,
            });
        }
        actionContext.dispatch('PDP_CONTACT_FORM_ERRORS', { errors });
        return errors;
    },

    prepareOffer(actionContext) {
        // TODO: no longer send message when when notes are no longer used
        const message = actionContext.getStore(ContactMessageStore).message;
        actionContext.dispatch('contact:form:offer:valid', { message });
    },

    /**
     *  Submits an offer
     *
     *  @param payload.bypassLowball {object}
     *  @returns {Deferred}
     */
    offer(actionContext, payload) {
        actions.prepareOffer(actionContext);
        const transaction = actionContext.getStore(ContactTransactionStore).transaction;
        const state = actionContext.getStore(ContactUIStore).state;
        transaction.unset('shipment');
        let sendToOmtOnSuccess = state.sendToOmtOnSuccess;
        let existingTransactionId;
        return transaction
            .save()
            .then(
                () =>
                    gaActions.eventOfferSuccess(actionContext, {
                        isOfferLow: payload.bypassLowball,
                    }),
                xhr => {
                    const itemId = transaction.get('item.id');
                    const userId = state.user.get('id');
                    const sendToOmtErrors = [
                        Transaction.ERROR_EXISTING_TRANSACTION,
                        Transaction.ERROR_DUPLICATE_ORDER,
                    ];
                    if (
                        xhr.responseJSON &&
                        contains(sendToOmtErrors, xhr.responseJSON.serviceResponseCode)
                    ) {
                        return Transactions.fetchExistingActiveOffersAndOrders(itemId, userId).then(
                            existingTransactions => {
                                if (existingTransactions.length) {
                                    existingTransactionId = existingTransactions.first().id;
                                    sendToOmtOnSuccess = true;
                                }
                            }
                        );
                    }
                    return undefined;
                }
            )
            .then(() => {
                if (!sendToOmtOnSuccess) {
                    return { offerSent: true };
                }
                checkoutRedirects.goToOMT(existingTransactionId);
                return Deferred();
            });
    },

    /**
     *  Submits an offer for pre-negotiations 2.0
     *
     *  @param payload.lowballOptions {bool}
     *  @returns {Deferred}
     */
    offerPreN2(actionContext) {
        actions.prepareOffer(actionContext);
        const { transaction, offer } = actionContext.getStore(ContactTransactionStore);
        const message = actionContext.getStore(ContactMessageStore).message;
        gaActions.eventOfferSuccessPreN2WithLowballOptions(actionContext, {
            offerAmount: offer.get('amountPerItem.amount'),
        });
        offer.redirectToCheckout({
            message: message.get('textBody'),
            item: transaction.get('item'),
        });

        // return pending deferred so no further action is taken
        return Deferred();
    },

    lowBallChange(actionContext) {
        actionContext.dispatch('contact:form:lowBall:hide');
    },
});



// WEBPACK FOOTER //
// ./assets/js/contact/shared/actions/transactionActions.es.js